const getters = {
  keywords: state => state.app.keywords,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  token: state => state.user.token,
  userId: state => state.user.userId,
  sex: state => state.user.sex
}
export default getters
